import { RestApiDataService } from '@/services/api/RestApiDataService'
import http from '@/services/http.service'
import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'
import store from '@/store'

const BASE_ENTITY_URL = '/menuItems'

class MenuItemsDataService extends RestApiDataService {
  getFilialMenu (filialId, filter = {}) {
    const source = this.http.CancelToken.source()
    const url = `${this.baseEntityUrl}/filial/${filialId}`
    store.dispatch('requests/addUniqueRequest', { url, source })

    return this.http.get(url, {
      params: filter,
      cancelToken: source.token,
    })
      .then((res) => res.data.items)
  }

  getOptionalMenu (filialId, filter = {}) {
    const source = this.http.CancelToken.source()
    const url = `${this.baseEntityUrl}/filial/${filialId}/optional`
    store.dispatch('requests/addUniqueRequest', { url, source })

    return this.http.get(url, {
      params: filter,
      cancelToken: source.token,
    })
      .then((res) => res.data.items)
  }

  addToFilial (menuItemId, filialId, source) {
    return http.patch(`${this.baseEntityUrl}/${menuItemId}/addToFilial`, { filialId, source })
      .then(res => res.data.data)
  }

  removeFromFilial (menuItemId, filialId, source) {
    return http.delete(`${this.baseEntityUrl}/${menuItemId}/removeFromFilial`, { data: { filialId, source } })
      .then(res => res.data.data)
  }
}

export default new MenuItemsDataService(BASE_ENTITY_URL)
